import React, { useState, useEffect, Fragment,useRef } from 'react';
import { Container, Row, Col, Card, Button, Input } from 'reactstrap';
import { connect } from 'react-redux';
import PCSelectedStarIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCSelectedStarIcon.svg';
import PCStarIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCStarIcon.svg';
import PCArchiveIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCArchiveIcon.svg';
import PCMarkAsReadIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCMarkAsReadIcon.svg';
import TablePagination from '../../../../../../Components/Pagination/TablePagination'
import Unarchive from '../../../../../../../designUtils/Storeoverview/PartnerLogs/Unarchive.svg';
import MarkAsUnread from '../../../../../../../designUtils/Storeoverview/PartnerLogs/MarkAsUnread.svg';
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import ArchiveNotifications from './ArchiveNotifications';
import FetchArchivedNotificationsService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/FetchArchivedNotificationsService';
import UpdateFavMessageService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/UpdateFavNotificationsService';
import UpdateArchiveNotificationsService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/UpdateArchiveNotificationsService';
import ReadUpdateIndicatorService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/ReadUpdateIndicatorService';
// import FetchArchivedNotifications from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/FetchArchivedNotifications';
import BAFewSelected from '../../../../../../../designUtils/Storeoverview/PartnerLogs/BAFewSelected.svg';
import BAAllSelected from '../../../../../../../designUtils/Storeoverview/PartnerLogs/BAAllSelected.svg';
import BACheckboxEmpty from '../../../../../../../designUtils/Storeoverview/PartnerLogs/BACheckboxEmpty.svg';
import BAOptionsDropdown from '../../../../../../../designUtils/Storeoverview/PartnerLogs/BAOptionsDropdown.svg';
import BARefresh from '../../../../../../../designUtils/Storeoverview/PartnerLogs/BARefresh.svg';
import { useHistory } from 'react-router-dom';
import urls from '../../../../../../../Utils/URLs';
import FetchAllNotificationsService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/FetchAllNotificationsService';


function NotificationsMainFile(props) {
  const history = useHistory();
  const [selectedTab, setSelectedTab] = useState('actionRequired');
  const [notificationDetails, setNotificationDetails] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [searchNoti, setSearchNoti] = useState('');
  const [searchArchivedNoti, setSearchArchivedNotii] = useState('');
  const [notiCount, setNotiCount] = useState('0');
  const [actionNotiCount, setActionNotiCount] = useState('0');
  const [userFullName, setUserFullName] = useState('');
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const [archivedCurrentPage,setArchivedCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [archiveNotiCount, setArchiveNotiCount] = useState('0');
  const [archivedPage,setArchivedPage]= useState(false)
  const [getBulkArchivedIds,setGetBulkArchivedIds]=useState([])
  const[refreshPage,setRefreshPage]= useState('');
  const [archiveNotificationDetails,setArchiveNotificationDetails]=useState({
    details:[],
    count:''
  })
  
  const[unreadCountCnt,setUnreadCountCnt]=useState([])
  const [show, setShow] = useState(false);
  const toggleRef = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedImgForCheckBox,setSelectedImgForCheckBox]=useState(true)

 
  const handleOptionClick = (option) => {
    // First, filter notifications based on the selected tab
    const baseFilterFunc = filterMap[selectedTab] || (() => true);
    const baseFiltered = notificationDetails && notificationDetails.filter(baseFilterFunc) || [];
  
    let filtered = [];
  
    // Now apply the second-level filter based on the selected option
    switch (option) {
      case 'Starred':
        filtered = baseFiltered.filter(noti => noti.Favourite === true);
        break;
      case 'Unstarred':
        filtered = baseFiltered.filter(noti => noti.Favourite === false);
        break;
      case 'Read':
        filtered = baseFiltered.filter(noti => noti.Read_Indicator === true);
        break;
      case 'Unread':
        filtered = baseFiltered.filter(noti => noti.Read_Indicator === false);
        break;
      case 'All':
        filtered = baseFiltered;
        break;
      case 'None':
        filtered = [];
        break;
      default:
        filtered = baseFiltered;
    }
  
    const ids = filtered.map(noti => noti.id);
  
    // If 'None' is selected, revert to showing all notifications from the tab
    if (option === 'None') {
      setFilteredNotifications(baseFiltered);
    } else {
      setFilteredNotifications(filtered);
    }
  
    setGetBulkArchivedIds(ids);
    setSelectedOptions(option);
  };
  const options = ['All', 'None', 'Read', 'Unread', 'Starred', 'Unstarred'];


  useEffect(() => {
    console.log('archivedPage');
    console.log(archivedPage);
    if(!archivedPage){
      fetchAllNotidata()
      setGetBulkArchivedIds([''])
      setSelectedOptions('None')
    }

  }, [archivedPage,refreshPage,props.store]);
  const fetchAllNotidata =()=>{
    setLoading(true)
    let data={
      searchparams:props.searchparams,
      intId:props.store.integerID?props.store.integerID:0
    }
    // Fetch initial notifications data
    FetchAllNotificationsService(props.token,data).then((res) => {
      console.log(res.notilist)
      if (res) {
        console.log(res)
        setNotiCount(res.noticount);
        setArchiveNotificationDetails({
          details:[],
          count:res.archiveNotiCount
        })
        setArchiveNotiCount(res.archiveNotiCount)
        setUserFullName(res.fullname);
        setNotificationDetails(res.notilist);
        const actionNotiCount = res.notilist.filter((noti) => noti.Notificationtype !== null && noti.Read_Indicator === false && noti.Archive === false).length;
        setActionNotiCount(actionNotiCount);
        filterNotifications(res.notilist, selectedTab, searchNoti); // Filter on load
        setLoading(false)
      }
    });

  }

  const fetchArchivedNotifications=(tab)=>{
    setArchivedPage(true)
    setSelectedTab(false)
    setLoading(true)
    let data={intId:props.store.integerID?props.store.integerID:0}
    FetchArchivedNotificationsService(props.token,data).then((res)=>{
        if(res){
        console.log(res);

        setArchiveNotificationDetails(
          {details:res.archivedNotilist,
          count:res.archiveNoticount})
          // filterArchiveNotifications( searchArchivedNoti);
          // setSelectedTab(tab);
          setLoading(false)
        }

      })
  }

  // Create a filter map for each tab
  const filterMap = {
    // archive: (noti) => noti.Archive === true,
    favourite: (noti) => noti.Favourite === true && noti.Archive === false,
    actionRequired: (noti) => noti.Notificationtype !== null && noti.Archive === false,
    all: (noti) => true && noti.Archive === false,
  };
  const handleFevMessage = (notifi) => {
    UpdateFavMessageService(props.token, { id: notifi.id ,searchparams:props.searchparams?props.searchparams:'',intId:props.store.integerID?props.store.integerID:0,}).then((res) => {
      if (res) {
        setNotificationDetails(res.favMessage.notilist);
        filterNotifications(res.favMessage.notilist, selectedTab, searchNoti); // Re-filter after updating favourite
      }
    });
  };
  // Filter notifications based on the current tab and search query
  const filterNotifications = (notilist, tab, searchQuery) => {
    console.log(tab);
    let filteredData = notilist || [];
    // Filter based on search query
    if (searchQuery) {
      filteredData = filteredData.filter((noti) =>
        noti.Message && noti.Message.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply tab-based filter using the filterMap object
    filteredData = filteredData.filter(filterMap[tab]);
    console.log('filteredData');
    console.log(filteredData);

    setFilteredNotifications(filteredData);
  };

  const handleTabClick = (tab) => {
    console.log(tab);
    setSelectedTab(tab);
    setCurrentPage(0);
    setArchivedCurrentPage(0);
    setArchivedPage(false)
    setGetBulkArchivedIds([''])
    setSelectedOptions('None')
    filterNotifications(notificationDetails, tab, searchNoti); // Re-filter notifications
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchNoti(query);
    filterNotifications(notificationDetails, selectedTab, query); // Filter based on search
    setCurrentPage(0)
  };
  const handleArchivedSearchChange = (e) => {
    setSearchArchivedNotii(e.target.value);
    setArchivedCurrentPage(0);  
    // filterArchiveNotifications(query); // Filter based on search
  };
  const handlePageChange = ({ currentPage, pageSize }) => {
    setCurrentPage(currentPage);
    setPageSize(pageSize);
  };
  
  const handleArchivedPageChange = ({ currentPage, pageSize }) => {
    setArchivedCurrentPage(currentPage);
    setPageSize(pageSize);
  };

const updateBulkArchivedNoti=()=>{
  let data ={id:getBulkArchivedIds,
    intId:props.store.integerID?props.store.integerID:0,
    searchparams:props.searchparams
  }
  UpdateArchiveNotificationsService(props.token, data).then((res) => {
    if (res) {
      console.log(res)
      setNotiCount(res.archiveMessage.noticount);
      if(selectedTab === 'actionRequired'){
        setActionNotiCount((prevCnt) => prevCnt - unreadCountCnt.length)
      }
      setArchiveNotificationDetails(
        {details:'',
        count:res.archiveMessage.archiveNotiCount})
      // setArchiveNotiCount(res.archiveMessage.archiveNotiCount)
      setNotificationDetails(res.archiveMessage.notilist);
      filterNotifications(res.archiveMessage.notilist, selectedTab, searchNoti); }
      setGetBulkArchivedIds([])

})
}

  const handleArchiveMessage = (notifi) => {
    let data = { id:[ notifi.id],
      intId:props.store.integerID ?props.store.integerID:0,
      searchparams:props.searchparams
     }
    UpdateArchiveNotificationsService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
        setNotificationDetails(res.archiveMessage.notilist);
        filterNotifications(res.archiveMessage.notilist, selectedTab, searchNoti); // Re-filter after archiving
        if (notifi.Read_Indicator === false) {
          // Decrease the appropriate notification count based on the selected tab
          if (selectedTab === 'actionRequired') {

            setActionNotiCount((prevCnt) => prevCnt - 1);
            setNotiCount((prevCnt) => prevCnt - 1);
            setArchiveNotiCount((prevCnt) => prevCnt + 1);
          } else if (selectedTab === 'all') {
            setNotiCount((prevCnt) => prevCnt - 1);
            if (notifi.Notificationtype !== null) {
              setActionNotiCount((prevCnt) => prevCnt - 1);
            }
            setArchiveNotiCount((prevCnt) => prevCnt + 1);
          }

          else if (selectedTab === 'archive') {
            setArchiveNotiCount((prevCnt) => prevCnt - 1);

            if (notifi.Notificationtype !== null) {
              setActionNotiCount((prevCnt) => prevCnt + 1);
              setNotiCount((prevCnt) => prevCnt + 1)
            } else {
              setNotiCount((prevCnt) => prevCnt + 1);
            }
          } else {
            setArchiveNotiCount((prevCnt) => prevCnt + 1);
          }
        }
      }
    });
  };

  const handleRedirctToComp =(notifi)=>{
    if(notifi.redirectTo =='ops/ticketList'){
      props.setNotificationsDetails && props.setNotificationsDetails({
        tabs: 2, //ticketList component
        details:notifi.Message,
        action:true,
        searchparams:notifi.searchparams

      })
    }
    else if(notifi.redirectTo =='trouble-ticket/all-ticket-list'){
      props.setNotificationsDetails && props.setNotificationsDetails({
        tabs: 2, //ticketList component
        details:notifi.Message,
        action:true,
        searchparams:notifi.searchparams

      })
    }
    else if(notifi.redirectTo=='ops/workflows')
    {
      // setNotificationText(notifi.Message)
      props.setNotificationsDetails && props.setNotificationsDetails({
        tabs: 1, //workflows component
        details:notifi.Message,
        action:true,
        searchparams:notifi.searchparams

      })
      
    }
    else if(notifi.redirectTo=='/dashboard')
      {
        props.setNotificationsDetails && props.setNotificationsDetails({
          tabs: 3, //dashboard component
          details:notifi.Message,
          action:true,
          searchparams:notifi.searchparams
        })
        
      }
      else if (notifi.redirectTo === '/Projects-Dashboard' && props.flag!='true') {
        const projectId = notifi.searchparams;
        
        if (!projectId) return;
        
        // Use URL search params to trigger direct project load
        history.push({
          pathname: urls.BASE_PROJECTS_DASHBOARD_URL,
          search: `?directProject=${projectId}&notification=${encodeURIComponent(notifi.Message)}&tab=assets`
        });
      }
      
    };
  const handleRedirect = (notifi, flag) => {
console.log(notifi)
    console.log(notifi.redirectTo);
    if (flag == 1 && notifi.redirectTo !== 'null' && notifi.redirectTo !== null) {
      if (notifi.Read_Indicator === false) {
        const data = { id: notifi.id ,
          intId:props.store.integerID,
          searchparams:props.searchparams?props.searchparams:''
        };

        ReadUpdateIndicatorService(props.token, data).then((res) => {
          if (res) {
            setNotificationDetails(res.readUpdateIndicator.notilist);
            setActionNotiCount((prevCnt) => prevCnt - 1);
            filterNotifications(res.readUpdateIndicator.notilist, selectedTab, searchNoti); // Re-filter after marking as read
          }
        });
      }
      handleRedirctToComp(notifi)
      // const baseUrl = window.location.origin;
      // window.location.href = `${baseUrl}${notifi.redirectTo.startsWith('/') ? notifi.redirectTo : '/' + notifi.redirectTo}`;
    }
    else if(flag==2) {

      const data = { id: notifi.id ,
        intId:props.store.integerID,
        searchparams:props.searchparams?props.searchparams:''
      };
      ReadUpdateIndicatorService(props.token, data).then((res) => {
        if (res) {
          setNotificationDetails(res.readUpdateIndicator.notilist);
          filterNotifications(res.readUpdateIndicator.notilist, selectedTab, searchNoti); // Re-filter after marking as read
        }
        if (notifi.Read_Indicator == false) {
          if (selectedTab === 'actionRequired') {
            setActionNotiCount((prevCnt) => prevCnt - 1);
          }
          else if (selectedTab === 'archive') {
            setArchiveNotiCount((prevCnt) => prevCnt - 1)
          }
          else {
            setNotiCount((prevCnt) => prevCnt - 1)
          }
        }
        else {
          if (selectedTab === 'actionRequired') {
            setActionNotiCount((prevCnt) => prevCnt + 1);
          }
          else if (selectedTab === 'archive') {
            setArchiveNotiCount((prevCnt) => prevCnt + 1)
          }
          else {
            setNotiCount((prevCnt) => prevCnt + 1)
          }
        }

      })
    }
    else {
      if (notifi.Read_Indicator === false) {
        const data = { id: notifi.id ,
          intId:props.store.integerID?props.store.integerID:0,
          searchparams:props.searchparams?props.searchparams:''
        };

        ReadUpdateIndicatorService(props.token, data).then((res) => {
          if (res) {
            setNotificationDetails(res.readUpdateIndicator.notilist);
            setActionNotiCount((prevCnt) => prevCnt - 1);
            filterNotifications(res.readUpdateIndicator.notilist, selectedTab, searchNoti); // Re-filter after marking as read
          }
        });
      }
    }
  };

  const handleBulkArchived=(noti)=>{
    setUnreadCountCnt((prevIds) => noti.Read_Indicator === false?prevIds.filter(i=>i==noti.id):
  [...prevIds,noti.id] )
    // setUnreadCountCnt()
    setGetBulkArchivedIds(prevIds =>
      prevIds.includes(noti.id)
        ? prevIds.filter(i => i !== noti.id) // toggle off
        : [...prevIds, noti.id]              // toggle on
    );
  }

  const filterArchived = archiveNotificationDetails.details && archiveNotificationDetails.details.filter((archNoti) => {
    const noti = archNoti.Message.toLowerCase();
    return noti.includes(searchArchivedNoti.toLowerCase());
  });
  const startIndex = currentPage * pageSize;
  const ArchivedstartIndex = archivedCurrentPage * pageSize;
  const paginatedNotifications = filteredNotifications.slice(startIndex, startIndex + pageSize);
  const paginatedArchivedNotifications = filterArchived.slice(ArchivedstartIndex, ArchivedstartIndex + pageSize);

  return (
    <Fragment >

      {/* <Card className={`card-of-problemarea mt-5 pl-3 pr-3 pb-3 ${props.isMyworksScreen == true ? 'pt-0' : 'pt-5'}`}> */}
      <Card className={`card-of-problemarea pl-3 pr-3
        ${props.hideProjectDashNotifications ? '' : 'mt-5 pb-3'}
        ${props.isMyworksScreen ? 'pt-0' : (props.hideProjectDashNotifications ? '' : 'pt-5')}`}>
        {/* <Row>
        <Col md={12} className={(props.isMyworksScreen || !props.hideProjectDashNotifications) ? 'p-0' : 'd-none'}>
            <h5 className='ml-4'><b>Hello, {userFullName}</b></h5>
            <p className="ml-4 large-font"><b>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</b></p>

          </Col>
      
        </Row> */}
        <Row>
          <Col md={12} className='mb-2 '>
          <Row className="">
          <Col md={8} className={`d-flex ${props.hideProjectDashNotifications ? '' : 'mt-4'}`}>
            {
              !archivedPage &&
              <>
               <div className="position-relative d-inline-block ml-1">
               
               {selectedImgForCheckBox?
               <img
               src={ BACheckboxEmpty}
               alt="Selection state"
               onClick={()=>{setSelectedImgForCheckBox(false);handleOptionClick('All')}}
               className="mr-1"
             />:
             <img
              src={
                selectedOptions=='' ||selectedOptions =='None'
                  ? BACheckboxEmpty
                  : selectedOptions =='All'?BAAllSelected:BAFewSelected
              }
              alt="Selection state"
             onClick={()=>{setSelectedImgForCheckBox(true);handleOptionClick('None')}}
              className="mr-1"
            />
          }
                 

            <img
              src={BAOptionsDropdown}
              alt="Dropdown arrow"
              onClick={() => {setShow(!show)}}
              style={{cursor:'pointer'}}
            />

            {show && (
            <div className="dropdown-menu show p-0 mt-1 shadow" style={{ minWidth: 140 }}>
                      <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
            {options.map((option, index) => (
              <li className='ml-4'
                key={index}
                onClick={() => {
                  handleOptionClick(option);
                  setShow(false);
                  setSelectedImgForCheckBox(false);
                }}
                style={{
                  cursor: 'pointer',
                  fontWeight: selectedOptions === option ? 'bold' : 'normal',
                  padding: '4px 8px'
                }}
              >
                {option}
              </li>
            ))}
          </ul>

            </div>
          )}

              </div>
              <div className="ml-3">
              <img
                src={PCArchiveIcon} 
                alt="Archive"
                style={{ cursor: getBulkArchivedIds.length > 0 ? 'pointer' : 'not-allowed', opacity: getBulkArchivedIds.length > 0 ? 1 : 0.5 }}
                onClick={getBulkArchivedIds.length > 0 ? updateBulkArchivedNoti : undefined}
                title='Archive'
              />
              </div>
              <div className="ml-3">
              <img
                src={BARefresh} 
                onClick={() => setRefreshPage(prev => !prev)}
                style={{cursor:'pointer'}}
                alt="Refresh"
                title='Refresh'
              />
              </div>
              </>
            }
           
            </Col>
            <Col md={4}>
            <div className={` ${props.isMyworksScreen == true ? " mt-2 mb-3 d-flex justify-content-end" : "d-flex justify-content-end"}`}>
             {
              archivedPage ?
              <input
                type="text"
                className=" form-control w-50"
                placeholder="Search..."
                // style={{ width: '98%' }}
                value={searchArchivedNoti}
                onChange={handleArchivedSearchChange}
              />:
              <input
                type="text"
                className="form-control w-50"
                placeholder="Search..."
                // style={{ width: '98%' }}
                value={searchNoti}
                onChange={handleSearchChange}
              />
             } 
               
            </div>
          </Col>
            
            </Row>
            <Row>
              <Col md={8} className="mt-2 d-flex">
                <h6 onClick={() => handleTabClick('favourite')}>
                  <img src={selectedTab === 'favourite' ? PCSelectedStarIcon : PCStarIcon} alt="Favourite Icon" className="headerstar-icon" />
                </h6>
                <h6 onClick={() => handleTabClick('actionRequired')}>
                  <span className={`${selectedTab === 'actionRequired' ? 'selected-action' : 'not-selected-action'} mr-5 ml-4`}>
                    {/* <b>Action Required</b><b className="messagenum">{actionNotiCount}</b> */}
                    <b>Action Required</b>{actionNotiCount > 0 && <b className="messagenum">{actionNotiCount}</b>}
                  </span>
                </h6>
                <h6 onClick={() => {handleTabClick('all')}}>
                  <span className={`${selectedTab === 'all' ? 'selected-action' : 'not-selected-action'}`}>
                    {/* <b>Notifications</b><b className="messagenum">{notiCount}</b> */}
                    <b>Notifications</b>{notiCount > 0 && <b className="messagenum">{notiCount}</b>}
                  </span>
                </h6>
                <h6 className='ml-5' onClick={() => fetchArchivedNotifications('')}>
                  <span className={`${archivedPage? 'selected-action' : 'not-selected-action'}`}>
                    {/* <b>Archived</b><b className="messagenum">{archiveNotiCount}</b> */}
                    <b>Archived</b>{archiveNotiCount > 0 && <b className="messagenum">{archiveNotiCount}</b>}

                  </span>
                </h6>
              </Col>
              <Col md={4} className={`mb-4 mt-1 d-flex justify-content-end pagination-item ${props.hideProjectDashNotifications ? 'mt-3' : ''}`}>
              {
              archivedPage ?
              <TablePagination
                  pageSize={pageSize}
                  totalRecords={filterArchived.length}
                  onPageChange={handleArchivedPageChange}
                  // pageNums={pageNums}
                  currentPage={archivedCurrentPage}
                />:
              <TablePagination
                  pageSize={pageSize}
                  totalRecords={filteredNotifications.length}
                  onPageChange={handlePageChange}
                  // pageNums={pageNums}
                  currentPage={currentPage}
                />
             } 
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <LoadingOverlay
        className='mt-2'
        active={loading}
        styles={{
          overlay: (base) => ({
            ...base,
            background: '#f1f4f6',
            opacity: 1,
          }),
          content: (base) => ({
            ...base,
            color: '#000',
          }),
        }}
        spinner={<Loader active type="ball-pulse" />}
        text='Loading your notifications...'
      >
        {archivedPage ?
      <ArchiveNotifications
      store={props.store} setStore={props.setStore}
      handleRedirctToComp={handleRedirctToComp}
      setArchiveNotificationDetails={setArchiveNotificationDetails}
      setArchiveNotiCount={setArchiveNotiCount}
      archiveNotiCount={archiveNotiCount}
      archiveNotifications={paginatedArchivedNotifications}/>
      :
        <Card className="card-of-problemarea p-3 ">
    <>

      {paginatedNotifications && paginatedNotifications.map((notifi, index) => {
        return (
          <Row key={index} className="row-hover-effect notification-item" style={{ cursor: 'pointer' }}>
           
            <Col md={1} className='pt-1 d-flex align-items-center'>
                  <input
                        type="checkbox"
                        className="mr-2"
                        // value={getBulkArchivedIds.includes(notifi.id)}
                        checked={getBulkArchivedIds.includes(notifi.id)}
                        onChange={()=>handleBulkArchived(notifi)}
                      />
              <h6>
                <img
                  onClick={() => handleFevMessage(notifi)}
                  src={notifi.Favourite === true ? PCSelectedStarIcon : PCStarIcon}
                  alt="Icon"
                  className="star-icon"
                />
              </h6>
            </Col>
            <Col md={1}>
            <Row >
            <Col md={12} className={`pt-1 ml-2 d-flex justify-content-end archive-item ${props.hideProjectDashNotifications ? 'ml-5' : ''}`}>
                    <h6 className="mark-as-read-icon" onClick={() => handleArchiveMessage(notifi)}>
                      <img src={PCArchiveIcon} alt="Archive Icon" className="archive" title="Archive" />
                    </h6>
                  {!notifi.Read_Indicator && (
                    <h6 className="ml-4 mark-as-read-icon" onClick={() => handleRedirect(notifi, 2)}>
                      <img src={PCMarkAsReadIcon} alt="Mark as Read Icon" className="mark-as-read" title="Mark as read" />
                    </h6>
                  )}
                  {notifi.Read_Indicator && (
                    <h6 className="ml-4 mark-as-read-icon" onClick={() => handleRedirect(notifi, 2)}>
                      <img src={MarkAsUnread} alt="Mark as Read Icon" className="mark-as-read" title="Mark as Unread" />
                    </h6>
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={10} onClick={() => handleRedirect(notifi, 1)}>
              <Row className='ml-2'>
                <Col md={3} className="pt-0">
                  <h6 className={notifi.Read_Indicator === false ? 'bold-text' : 'normal-text'}>{notifi.createdAtFormated}</h6>
                </Col>
                <Col md={9} className="pt-0">
                  <h6 dangerouslySetInnerHTML={{ __html: notifi.Message }} className={notifi.Read_Indicator === false ? 'bold-text' : 'normal-text'}></h6>
                </Col>
              </Row>
            </Col>
            <Col md={12}>
              <hr className="line-pg p-0 m-0"></hr>
            </Col>
          </Row>
        );
      })}
    </>
  </Card>
     
        }
       
      </LoadingOverlay>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    globalPermissions: state.loggedUser.globalPermissions,
    storeOverview: state.accountOverview.store.storeOverview,
    storeProducts: state.accountOverview.store.storeProducts,
    childProducts: state.accountOverview.store.childProducts,
    parentProducts: state.accountOverview.store.parentProducts,
    adProfiles: state.accountOverview.landing.adProfiles,
    roles: state.loggedUser.roles
  };
};

export default connect(mapStateToProps)(NotificationsMainFile);
